import axios from 'axios';
import { BASE_URL, TIMEOUT } from './config';

// 创建axios实例
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 注入登录态：FastAdmin Api 基类从 HTTP_TOKEN 头读取 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['TOKEN'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 标记是否正在跳转登录页，避免多个 401 同时触发多次跳转
let isRedirecting = false;

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 返回完整的响应数据
    const res = response.data;
    if (res.code === 1) {
      return res;
    } else {
      console.error('API请求错误:', res.msg);
      // 未登录或 token 失效（FastAdmin 约定 code 401 / -1 + 未登录提示）
      if (res.code === 401 || (typeof res.msg === 'string' && res.msg.indexOf('未登录') >= 0) || (typeof res.msg === 'string' && res.msg.indexOf('登录') >= 0 && res.msg.indexOf('过期') >= 0)) {
        handleUnauthorized();
      }
      return Promise.reject(new Error(res.msg || '请求失败'));
    }
  },
  error => {
    console.error('请求错误:', error);
    // HTTP 401 / 403
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      handleUnauthorized();
    }
    // 提取后端返回的错误消息（如"余额不足，请先充值"），无消息时回退到 axios 原始消息
    const backendMsg = error.response?.data?.msg;
    return Promise.reject(new Error(backendMsg || error.message || '请求失败'));
  }
);

// 统一处理未授权：清除登录态并跳转登录页
function handleUnauthorized() {
  if (isRedirecting) return;
  isRedirecting = true;
  localStorage.removeItem('userInfo');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenTime');
  // 使用 hash 路由，跳转到登录页
  const currentHash = window.location.hash;
  const redirect = currentHash.replace(/^#/, '') || '/';
  window.location.hash = '#/login?redirect=' + encodeURIComponent(redirect);
  setTimeout(() => { isRedirecting = false; }, 1000);
}

export default instance; 